import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import { injectIntl } from "react-intl";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import * as auth from "../_redux/authRedux";
import { newPassword } from "../_redux/authCrud";

const initialValues = {
  email: "",
};

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function NewPassword(props) {
  let query = useQuery();
  const [isRequested, setIsRequested] = useState(false);
  const [showPasswords, setShowPasswords] = useState(false);
  const NewPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .matches(
        /^((?=.*[a-z])(?=.*[A-Z])(?=.*\d)).{8,30}$/,
        "Caractères obligatoires: au moins une minuscule, une majuscule, un chiffre et 8 caractères minimum"
      )
      .required(
        "Mot de passe requis"
        /*
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
        */
      ),
    confirm_password: Yup.string()
      .oneOf(
        [Yup.ref("password"), null],
        "Les mots de passe ne correspondent pas"
      )
      .required(
        "Les mots de passe ne correspondent pas"
        /*
        intl.formatMessage({
          id: "AUTH.VALIDATION.REQUIRED_FIELD",
        })
        */
      ),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: NewPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      newPassword({
        password: values.password,
        resetGuid: query.get("token"),
      })
        .then((response) => {
          console.log(response);
          setIsRequested(true);
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response) {
            switch (error.response.data.error) {
              case "EXPIRED_GUID":
                setStatus("Lien expiré. Demandez un nouveau lien depuis l’application Odopass.");
                break;
              case "SAME_PASSWORD":
                setStatus(
                  "Vous ne pouvez pas utiliser votre ancien mot de passe."
                );
                break;
              default:
                setStatus("Une erreur est survenue.");
                break;
            }
            console.log(error.response.data);
          }

          setIsRequested(false);
          setSubmitting(false);
        });
    },
  });

  return (
    <>
      {isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-5">
            <h3 className="font-size-h1">Nouveau mot de passe</h3>
          </div>
          <div className="alert alert-custom alert-light-success alert-dismissible">
            <div className="alert-text font-weight-bold" style={{ color: "#38ba3a" }}>
              Nouveau mot de passe enregistré ! Connectez-vous à votre compte Odopass depuis l'application
            </div>
          </div>
          <div className="form-group">
            <a
              href="https://pro.odopass.tech/open/garage/f52abd2d_7114_4b8d_be5d_f7aa94018712"
              className="btn blue-odopass font-weight-bold w-100 py-4"
            >
              Ouvrir l'application
            </a>
          </div>
        </div>
      )}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10">
            <h3 className="font-size-h1">Nouveau mot de passe</h3>
            <h4 className="font-size-h6 text-dark-50 text-left">• 8 caractères ou plus</h4>
            <h4 className="font-size-h6 text-dark-50 text-left">• 1 chiffre, 1 lettre majuscule et 1 lettre minuscule</h4>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {formik.status && (
              <div className="mb-5 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            <div className="form-group fv-plugins-icon-container form-control-iconless">
              <div className="position-relative">
                <input
                  type={showPasswords ? "text" : "password"}
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "password"
                  )}`}
                  placeholder="Mot de passe"
                  name="password"
                  style={{ borderRadius: "8px", paddingRight: "2.5rem", backgroundImage: "none" }}
                  {...formik.getFieldProps("password")}
                />
                <button
                  type="button"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => setShowPasswords(!showPasswords)}
                  aria-label={showPasswords ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {showPasswords ? (
                    <VisibilityOutlinedIcon />
                  ) : (
                    <VisibilityOffOutlinedIcon />
                  )}
                </button>
              </div>
              {formik.touched.password && formik.errors.password ? (
                <div className="mt-1 alert alert-custom alert-light-danger alert-dismissible">
                  <div className="alert-text font-weight-bold">
                    {formik.errors.password}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="form-group fv-plugins-icon-container form-control-iconless">
              <div className="position-relative">
                <input
                  type={showPasswords ? "text" : "password"}
                  className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "confirm_password"
                  )}`}
                  placeholder="Confirmer le mot de passe"
                  name="confirm_password"
                  style={{ borderRadius: "8px", paddingRight: "2.5rem", backgroundImage: "none" }}
                  {...formik.getFieldProps("confirm_password")}
                />
                <button
                  type="button"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => setShowPasswords(!showPasswords)}
                  aria-label={showPasswords ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    padding: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {showPasswords ? (
                    <VisibilityOutlinedIcon />
                  ) : (
                    <VisibilityOffOutlinedIcon />
                  )}
                </button>
              </div>
              {formik.touched.confirm_password &&
                formik.errors.confirm_password ? (
                <div className="mt-1 alert alert-custom alert-light-danger alert-dismissible">
                  <div className="alert-text font-weight-bold">
                    {formik.errors.confirm_password}
                  </div>
                </div>
              ) : null}
            </div>
            <div className="form-group">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn blue-odopass font-weight-bold w-100 py-4"
                disabled={formik.isSubmitting || !formik.isValid || !formik.values.password || !formik.values.confirm_password}
              >
                Enregistrer
              </button>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(NewPassword));
